import { inject, Injectable } from '@angular/core';
import {
  API_URL,
  APP_NAME,
  COASSESS_MENU_ITEMS,
  COREACT_MENU_ITEMS,
} from '../../utils';
import { LayoutService } from './layout.service';

@Injectable({
  providedIn: 'root',
})
export class MenuItemsService {
  private appName = inject(APP_NAME);
  private layoutService = inject(LayoutService);
  private menuItems =
    this.appName === 'coassess' ? COASSESS_MENU_ITEMS : COREACT_MENU_ITEMS;

  constructor() {}

  setMenuItems(role: string) {
  const menuItems = this.menuItems
    .map((menuGroup) => {
      return {
        ...menuGroup,
        items: menuGroup.items
          ?.filter(
            (item) =>
              !item.roles || item.roles.includes(role)
          )
          .map((item) => {
            return {
              ...item,
              items: item.items?.filter(
                (child) => !child.roles || child.roles.includes(role)
              ),
            };
          })
          .filter((item) => item?.items?.length! > 0 || !item.items)
      };
    })
    .filter((menuGroup) => menuGroup.items?.length! > 0);

  this.layoutService.setSidebarMenuItems(menuItems);
}
}
